<script lang="ts">
  import { page } from '$app/stores';
  import type { LayoutPreference } from '$types/races';
  import { createPopover } from 'svelte-headlessui';
  import { Transition } from 'svelte-transition';
  import { get } from 'svelte/store';
  import TablerChevronDown from '~icons/tabler/chevron-down';

  $: ({ layoutConfigStore } = $page.data);

  export let layoutPreference: LayoutPreference;

  let type = '';
  $: {
    if (layoutPreference.bookmaker === 'Betfair') {
      if (layoutPreference.side === 'BACK') {
        type = layoutPreference.type === 'FIXED_WIN_FLUCS' ? 'WB' : 'PB';
      } else {
        type = layoutPreference.type === 'FIXED_WIN_FLUCS' ? 'WL' : 'PL';
      }
    } else {
      type = layoutPreference.type === 'FIXED_WIN_FLUCS' ? 'FW' : 'FP';
    }
  }

  const popover = createPopover();

  function setPeriod(period: LayoutPreference['period']) {
    popover.close();
    layoutPreference.period = period;

    if (!layoutConfigStore?.activeLayoutConfigName) return;

    const activeName = get(layoutConfigStore.activeLayoutConfigName);
    layoutConfigStore.updateLayoutPreference(activeName, layoutPreference);
  }

  $: display = '';
  $: {
    if (layoutPreference.period === 'ALL') {
      display = 'ALL';
    } else if (layoutPreference.period === 'ONE_MINUTE') {
      display = '1M';
    } else if (layoutPreference.period === 'FIVE_MINUTES') {
      display = '5M';
    } else if (layoutPreference.period === 'NINE_AM') {
      display = '9AM';
    } else if (layoutPreference.period === 'SIX_AM') {
      display = '6AM';
    } else if (layoutPreference.period === 'TEN_MINUTES') {
      display = '10M';
    } else if (layoutPreference.period === 'THIRTY_MINUTES') {
      display = '30M';
    } else if (layoutPreference.period === 'ONE_HOUR') {
      display = '1H';
    } else if (layoutPreference.period === 'TWELEVE_HOURS') {
      display = '12H';
    } else {
      display = layoutPreference.period ?? 'ALL';
    }
  }

  let bgClass = '';
  $: {
    if (layoutPreference.bookmaker === 'Betfair') {
      if (layoutPreference.side === 'BACK') bgClass = 'bg-blue-100';
      else bgClass = 'bg-red-100';
    }
  }
</script>

<div
  class="flex w-full cursor-pointer select-none items-center justify-center truncate rounded-sm {bgClass}"
  class:hover:bg-slate-200={layoutPreference.type === 'FIXED_WIN_FLUCS'}
  class:hover:bg-slate-400={layoutPreference.type === 'FIXED_PLACE_FLUCS'}
>
  <div use:popover.button class="flex h-full w-full justify-center">
    {type} - {display}

    {#if !$popover.expanded}
      <TablerChevronDown class="h-4 w-4" />
    {:else}
      <div class="rotate-180">
        <TablerChevronDown class="h-4 w-4" />
      </div>
    {/if}
  </div>
  <Transition show={$popover.expanded}>
    <div
      use:popover.panel
      class="absolute top-5 z-50 flex w-full cursor-pointer flex-col items-center divide-y rounded-sm border border-gray-200 bg-white shadow-sm"
    >
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('ALL')}
        on:keypress={() => setPeriod('ALL')}
      >
        All
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('SIX_AM')}
        on:keypress={() => setPeriod('SIX_AM')}
      >
        6am
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('NINE_AM')}
        on:keypress={() => setPeriod('NINE_AM')}
      >
        9am
      </button>

      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('ONE_MINUTE')}
        on:keypress={() => setPeriod('ONE_MINUTE')}
      >
        1 Minute
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('FIVE_MINUTES')}
        on:keypress={() => setPeriod('FIVE_MINUTES')}
      >
        5 Minutes
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('TEN_MINUTES')}
        on:keypress={() => setPeriod('TEN_MINUTES')}
      >
        10 Minutes
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('THIRTY_MINUTES')}
        on:keypress={() => setPeriod('THIRTY_MINUTES')}
      >
        30 Minutes
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('ONE_HOUR')}
        on:keypress={() => setPeriod('ONE_HOUR')}
      >
        1 Hour
      </button>
      <button
        class="w-full p-1 text-center hover:bg-gray-100"
        on:click={() => setPeriod('TWELEVE_HOURS')}
        on:keypress={() => setPeriod('TWELEVE_HOURS')}
      >
        12 Hours
      </button>
    </div>
  </Transition>
</div>
